export const AAPromptStates = {
  Idle: 'IDLE',
  Started: 'STARTED',
  Finished: 'FINISHED'
};